import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {getStore} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from 'react-router-dom';
import { withSnackbar } from 'notistack';
import {platforms, TableCount, TablePage,platformsWithName} from "../../../../config/Permissions";
import moment from "jalali-moment";
import Container from "@material-ui/core/Container/Container";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import SportsEsportsRoundedIcon from '@material-ui/icons/SportsEsportsRounded';

class SafeCoins extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    type = this.props.match.params.type;
    state = {
        columns : [
            {
                title: Translate.coins_count,
                field: 'count',
                editComponent: props => (
                    <TextField
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{Translate.k}</InputAdornment>,
                        }}
                        value={props.value}
                        onChange={e => props.onChange(e.target.value)}
                    />
                )
            },
            { title: Translate.price,
                field: 'price',
                editComponent: props => (
                    <TextField
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        value={props.value}
                        onChange={e => props.onChange(e.target.value)}
                    />
                )
            },
            {
                title: Translate.delivery_from,
                field: 'delivery_from',
                editComponent: props => (
                    <TextField
                        InputProps={{
                            endAdornment: <InputAdornment position="end">Hours</InputAdornment>,
                        }}
                        value={props.value}
                        onChange={e => props.onChange(e.target.value)}
                    />
                )
            },
            {
                title: Translate.delivery_to,
                field: 'delivery_to',
                editComponent: props => (
                    <TextField
                        InputProps={{
                            endAdornment: <InputAdornment position="end">Hours</InputAdornment>,
                        }}
                        value={props.value}
                        onChange={e => props.onChange(e.target.value)}
                    />
                )
            },
            {
                title: Translate.categoryName,
                field: 'category',
                lookup: platforms,
            },
            { title: Translate.lastUpdate, field: 'lastUpdate',editable:"never"},
        ],
        data: [],
        platforms: [],
        loading:false,
        type: this.type ? this.type : "all",
        ChangeLoader:false
    };
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(newProps){
        if(newProps !== this.props){
            let newtype = this.props.match.params.type;
            await this.setState({
                type: newtype ? newtype : "all",
                ChangeLoader:true
            })
            await this.loadData();
        }
    }

    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/safecoin/delete`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteData, {
                        variant: 'success',
                    });
                }
                this.loadData();
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                this.loadData();
                return false
            });
    }
    onEdit(coin) {
        let authUser = getStore().user;
        if(authUser.role.permission.manageSettings){
            let data = new FormData();
            data.append('id', !! coin.id ? coin.id : "");
            data.append('count', coin.count);
            data.append('price', coin.price);
            data.append('delivery_from', coin.delivery_from);
            data.append('delivery_to', coin.delivery_to);
            data.append('category', coin.category);
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/safecoin/make`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.detailsSet, {
                        variant: 'success',
                    });
                    this.loadData();
                    return true
                })
                .catch(error => {
                    console.log(error.response)
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                    return false
                });
        }else{
            this.props.enqueueSnackbar(Translate.youDontHavePermission, {
                variant: 'error',
            });
            this.loadData();
        }

    }
    async handleChangeType(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let type = target.value;
        this.props.history.push(`/manage/safe-coins/${type}`)

        await this.setState({
            type,
        });
        this.loadData();
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let {type} = this.state;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const data = new FormData();
        data.append('category', type);
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className="safecoin-container">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={
                                            <TextField
                                                select
                                                fullWidth
                                                value={type}
                                                size="small"
                                                onChange={this.handleChangeType.bind(this)}
                                                label={Translate.choosePlatform}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">
                                                        <SportsEsportsRoundedIcon style={{color:'rgba(0, 0, 0, 0.54)'}}/>

                                                    </InputAdornment>,
                                                }}
                                            >
                                                <MenuItem value='all'>{Translate.allPlatforms}</MenuItem>
                                                {
                                                    platformsWithName.map((row,index) => (
                                                        <MenuItem key={index} value={row.value}>{row.name}</MenuItem>
                                                    ))
                                                }
                                            </TextField>
                                        }

                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.post(`${defaultVariabls.url}/safecoin/get?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`,data, config)
                                                    .then(response => {
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.data.map((row) => {
                                                            data.push({
                                                                count: row.count,
                                                                delivery_to: row.delivery_to,
                                                                delivery_from: row.delivery_from,
                                                                price: row.price,
                                                                category: row.category.slug,
                                                                id: row.id,
                                                                lastUpdate:`${moment(row.updated_at).fromNow()}`
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,
                                        }}
                                        editable={{
                                            onRowAdd: newData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onEdit(newData);
                                                    }, 600)
                                                }),
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onEdit(newData);
                                                        if (oldData) {
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data[data.indexOf(oldData)] = newData;
                                                                return { ...prevState, data };
                                                            });
                                                        }
                                                    }, 600);
                                                }),
                                            onRowDelete: oldData =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onDelete(oldData.id);
                                                        this.setState(prevState => {
                                                            const data = [...prevState.data];
                                                            data.splice(data.indexOf(oldData), 1);
                                                            return { ...prevState, data };
                                                        });
                                                    }, 600);
                                                }),
                                        }}

                                    />
                                </Grid>
                            </Grid>
                        </Container>
                }
            </>
        );
    }
}

export default  withWidth()(withSnackbar(withRouter(withStyles(Styles)(SafeCoins))));